import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import CircularProgress from '@mui/material/CircularProgress';
import { Chip } from '@mui/material';
import { FilterAlt } from '@mui/icons-material';
import Box from '../Box/Box';
const useStyles = makeStyles(createStyles({
    root: {
        '@media (min-width:600px)': {
            paddingInline: '1.5em',
        },
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
    },
    resultCategoriesLabel: {
        color: '#5E5E5E',
        '@media (min-width:600px)': {
            mixBlendMode: 'unset',
            color: '#EFEFEF',
        },
        display: 'flex',
        paddingRight: '0.6em',
        alignItems: 'center',
        fontWeight: 'bolder',
    },
    resultCategoriesChip: {
        height: '2.5em',
        color: '#5E5E5E',
        alignItems: 'center',
        '@media (min-width:600px)': {
            mixBlendMode: 'unset',
            color: '#EFEFEF',
            marginTop: 'auto',
        },
        fontWeight: 'bolder',
        marginRight: '10px',
    },
    chipIcon: {
        color: '#5E5E5E',
        '@media (min-width:600px)': {
            mixBlendMode: 'unset',
            color: '#EFEFEF !important',
        },
    },
    chipContainer: {
        display: 'flex',
        flex: '1',
        overflow: 'auto',
        scrollbarWidth: 'thin',
        alignItems: 'center',
        paddingTop: '7px',
        paddingBottom: '7px',
        '@media (min-width:600px)': {
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
    addButton: {
        color: 'white',
        '@media (min-width:600px)': {
            color: 'rgba(0,0,0,0.8)',
        },
        '& .Mui-disabled': {
            color: 'rgba(256,256,256, 0.3)',
        },
    },
    progressIndicator: {
        marginLeft: '0.2em',
        marginBottom: 'auto',
        marginTop: 'auto',
    },
}));
function SearchResultCategoriesBar(props) {
    const classes = useStyles();
    const { resultCategories, onAddButtonTap, searchInProgress, } = props;
    if (searchInProgress) {
        return (_jsxs(Box, { className: classes.root, children: [_jsx(Typography, { variant: "caption", className: `${classes.resultCategoriesLabel} resultCategoriesLabel`, children: "Search in progress " }), _jsx(CircularProgress, { color: "warning", size: "1em", className: classes.progressIndicator, thickness: 7 })] }));
    }
    return (resultCategories.length > 1 || resultCategories.some(category => category.values.length > 10) ? (_jsxs(Box, { className: classes.root, children: [_jsx(Typography, { variant: "caption", className: `${classes.resultCategoriesLabel} resultCategoriesLabel`, children: "Matches in:" }), _jsx(Box, { className: `${classes.chipContainer}`, children: resultCategories.map((appliedMatch, index) => (_jsx(Chip, { variant: "outlined", icon: _jsx(FilterAlt, { className: classes.chipIcon }), label: `${appliedMatch.label} (${appliedMatch.values.length})`, className: `${classes.resultCategoriesChip} resultCategoriesChip`, onClick: () => onAddButtonTap(appliedMatch) }, `appliedBadge_${index}`))) })] })) : _jsx(Box, { className: classes.root }));
}
export default SearchResultCategoriesBar;
